import { Checkbox, FormControl, FormControlLabel, FormHelperText } from "@mui/material";
import React from 'react';
import { SideSheetFieldPropsBase } from "../side-sheet/SideSheet";

export type SideSheetCheckboxProps = {
    checked: boolean;
    onChange?: (checked: boolean) => void | undefined;
    size?: 'small' | 'medium' | 'large'
} & SideSheetFieldPropsBase;

export default function SideSheetCheckbox({
    id,
    testId,
    label,
    ariaLabel,
    readOnly,
    helperText,
    sx,
    disabled,
    checked,
    onChange,
    size
}: SideSheetCheckboxProps) {

    return (
        <FormControl
            aria-label={ariaLabel}
            sx={{
                marginTop: 0,
                ...sx
            }}>
            <FormControlLabel
                aria-label={ariaLabel}
                control={
                    <Checkbox //color="primary"
                        id={id}
                        size={size}
                        data-testid={testId}
                        checked={checked}
                        readOnly={readOnly}
                        onChange={(_event, checked) => {
                            onChange && onChange(checked);
                        }}
                        disabled={disabled}
                    />
                }
                label={label ?? ''}
                labelPlacement="end"
            />
            {helperText &&
                <FormHelperText>{helperText}</FormHelperText>
            }
        </FormControl>
    );
}